import { ComponentProps } from "react";
import { MaterialGroupSelection } from "share-components/group-selection/material-group-selection/material-group-selection";

type MaterialGroupSelectionConnectedProps = ComponentProps<
  typeof MaterialGroupSelection
>;

export const MaterialGroupSelectionConnected = (
  props: MaterialGroupSelectionConnectedProps,
) => {
  return <MaterialGroupSelection {...props} />;
};
